import {
	Box,
	Button,
	Icons,
	Popover,
	Stack,
	Text,
	Inline,
} from "@sembark-travel/ui-base"
import type { TTemplateVariable } from "../../Integrations"

export function VariablePicker({
	variables,
	onInsert,
	disabled,
	containerRef,
}: {
	variables: Array<TTemplateVariable>
	onInsert: (variable: TTemplateVariable) => void
	containerRef: React.RefObject<HTMLElement | null>
	disabled?: boolean
}) {
	const variableCount = variables.length

	return (
		<Popover
			placement="bottom-start"
			trigger="click"
			container={containerRef}
			content={({ hide }) => (
				<Box overflow="auto" style={{ width: "340px", maxHeight: "385px" }}>
					<Stack>
						<Box paddingX="4" paddingY="3" borderBottomWidth="1">
							<Stack gap="1">
								<Text fontWeight="semibold" fontSize="sm">
									Insert Variable
								</Text>
							</Stack>
						</Box>

						<Stack>
							{variables.map((variable) => (
								<Box
									bgColor={"default"}
									key={variable.key}
									as="button"
									type="button"
									paddingX="4"
									paddingY="3"
									borderBottomWidth="1"
									textAlign="left"
									cursor="pointer"
									width="full"
									onClick={() => {
										onInsert(variable)
										hide()
									}}
								>
									<Stack gap="1">
										<Inline gap="2" alignItems="center" flexWrap="wrap">
											<Text fontWeight="semibold" fontSize="sm">
												{variable.label}
											</Text>
											<Box
												paddingX="2"
												paddingY="1"
												rounded="sm"
												display="inlineBlock"
											>
												<Text fontSize="xs" color="muted" fontFamily="mono">
													{variable.placeholder}
												</Text>
											</Box>
										</Inline>

										{variable.description ? (
											<Text fontSize="xs" color="muted">
												{variable.description}
											</Text>
										) : null}

										<Text fontSize="xs" color="primary">
											Sample: {variable.sample_value}
										</Text>
									</Stack>
								</Box>
							))}
						</Stack>

						{variableCount === 0 ? (
							<Box paddingX="4" paddingY="8" textAlign="center">
								<Stack gap="2" alignItems="center">
									<Icons.Tags size="8" color="muted" />
									<Text color="muted" fontSize="sm">
										No variables available
									</Text>
								</Stack>
							</Box>
						) : null}
					</Stack>
				</Box>
			)}
		>
			<Button size="sm" level="secondary" disabled={disabled} type="button">
				<Icons.Tags /> Insert Variable
			</Button>
		</Popover>
	)
}
